const openNavBtn = document.querySelectorAll(".adm-btn-nav-mobile")[1];
const sideNavContainer = openNavBtn?.nextElementSibling;
const sideNavAllLinks = sideNavContainer.querySelectorAll("button");

openNavBtn?.addEventListener("click", () => {
  if (sideNavContainer?.classList.contains("adm-ul-nav-mobile-opened")) {
    closeSideNavMobile();
  } else {
    openSideNavMobile();
  }
});

if (sideNavContainer) {
  setTimeout(() => {
    sideNavContainer.style.transition = "0.5s";
  }, 300);
}

const closeSideNavMobile = () => {
  sideNavContainer?.classList.remove("adm-ul-nav-mobile-opened");
  sideNavContainer?.setAttribute("aria-hidden", "true")
  openNavBtn?.classList.remove("adm-btn-nav-mobile-active");
  sideNavContainer.style.overflow = '';
  toggleSideNavLinks(sideNavAllLinks, "-1");
}

const openSideNavMobile = () => {
  sideNavContainer?.classList.add("adm-ul-nav-mobile-opened");
  sideNavContainer?.setAttribute("aria-hidden", "false")
  openNavBtn?.classList.add("adm-btn-nav-mobile-active");
  setTimeout(() => {
    sideNavAllLinks?.[0]?.focus();
  }, 0);
  toggleSideNavLinks(sideNavAllLinks, "0");
}

window.addEventListener('click', e => {
  if (
    !sideNavContainer?.contains(e.target) &&
    !openNavBtn?.contains(e.target)
  ) {
    closeSideNavMobile();
  } 
})

sideNavAllLinks?.[0]?.addEventListener("keydown", event => {
  const pressedKeyCode = event.which || event.keyCode;
  
  // TAB + Shift key press
  if (pressedKeyCode === 9 && event.shiftKey) {
    closeSideNavMobile();
  }
})

sideNavAllLinks?.[sideNavAllLinks.length - 1]?.addEventListener("keydown", event => {
  const pressedKeyCode = event.which || event.keyCode;
  
  // TAB key press
  if (pressedKeyCode === 9 && !event.shiftKey) {
    closeSideNavMobile();
  }
})

sideNavContainer?.addEventListener("keydown", event => {
  const pressedKeyCode = event.which || event.keyCode;
  
  // ESC key press
  if (pressedKeyCode === 27) {
    closeSideNavMobile();
    openNavBtn.focus();
  }
})

const toggleSideNavLinks = (elements, tabindex) => {
  for (const elem of elements) {
    elem?.setAttribute("tabindex", tabindex);
    switch (tabindex) {
      case "0":
        elem?.setAttribute("aria-hidden", "false");
        break;
      case "-1":
        elem?.setAttribute("aria-hidden", "true");
        break;
    }
  }
}
toggleSideNavLinks(sideNavAllLinks, "-1");

for (const btn of sideNavAllLinks) {
  btn.addEventListener("click", () => updateSelectedLangauge(btn));
}

const updateSelectedLangauge = clickedBtn => {
  const currentSvg = sideNavAllLinks?.[0].querySelector("svg");
  const svgClone = currentSvg.cloneNode(true);
  clickedBtn.appendChild(svgClone);
  currentSvg.remove();
}